(function () {
    'use strict';
    $(document).ready(function () {

        $(".play-video").modalVideo({
            youtube:{
                showinfo: 0
            }
        });

        var swiperBanner = new Swiper('.swiper-banner', {
            slidesPerView: 1,
            speed: 4000,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            breakpoints: {
                1199: {
                },
            },
            on:{
                slideChange: function(){
                    $('.swiper-outer-pagination button.active').removeClass('active');
                    $('.swiper-outer-pagination button').eq(this.activeIndex).addClass('active');

                    $('.banner .bg img.active').removeClass('active');
                    $('.banner .bg img').eq(this.activeIndex).addClass('active');
                }
            }
        });

        $('.swiper-outer-pagination button').on('click', function() {
            swiperBanner.slideTo($(this).data('index'));
        })


    });
}(jQuery));
